<template>
  <div>
    <!-- <el-dialog
      v-if="visible"
      show-close
      visible
      width="700px"
      :close-on-click-modal="false"
      :before-close="() => $emit('colse')"
      append-to-body
    >
      <span slot="title" class="dialog-title">
        <span>
          选择拜访记录
        </span>
      </span> -->
    <!-- <vxe-grid
        auto-resize
        highlight-hover-row
        :data="tableData"
        :columns="tableColumns"
        :loading="loading"
        :height="300"
        size="small"
        resizable
        border
        :radio-config="{ highlight: true }"
        @radio-change="radioChangeEvent"
      >
        <template v-slot:empty="{}">
          <div style="text-align: center">
            <img src="/image/static/img/nodata.png" />
            <p class="no-data">暂无数据！</p>
          </div>
        </template>
      </vxe-grid> -->
    <!-- <js-pagination
        class="mt-2"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="sm"
        align="right"
        @change="handlePaginationChange"
      /> -->
    <!-- <span slot="footer">
        <el-button size="small" @click="() => $emit('colse')">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="confirm()">{{
          $l('INDEX.tips_confirm') || '确认'
        }}</el-button>
      </span> -->
    <!-- </el-dialog> -->
    <el-dialog
      ref="scoreTemplateDialog"
      @opened="scoreTemplateDialogOpened"
      :title="$l('tips_choice_scoreTemplate') || '选择评分模板'"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="() => $emit('colse')"
      width="740px"
      append-to-body
    >
      <score-template
        ref="scoreTemplate"
        @success="choiceScoreTemplateSuccess"
        @cancel="choiceScoreTemplateCancel"
      ></score-template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    scmCode: { type: String, default: '' },
    visitCode: { type: String, default: '' },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq',
          fixed: 'left',
        },
        {
          width: 60,
          align: 'center',
          title: '选择',
          type: 'radio',
          fixed: 'left',
        },
        {
          field: 'visitDate',
          align: 'center',
          width: 120,
          title: '拜访日期',
        },
        {
          field: 'visitOwnerName',
          headerAlign: 'center',
          align: 'left',
          minWidth: 160,
          title: '拜访负责人',
        },
        {
          field: 'visitTitle',
          width: 220,
          headerAlign: 'center',
          align: 'left',
          title: '拜访目的',
        },
        {
          field: 'scmPerson',
          width: 160,
          title: '厂商人员',
          headerAlign: 'center',
          align: 'left',
        },
        {
          field: 'visitDescription',
          minWidth: 300,
          title: '拜访详情',
          headerAlign: 'center',
          align: 'left',
        },
      ],
      dialogFormVisible: false,
    }
  },
  components: {
    ScoreTemplate: () =>
      import(
        '@/views/digital/personal/myScmInfo/components/rating/scoreTemplate.vue'
      ),
  },
  watch: {
    scmCode: {
      handler() {
        this.getData()
      },
      immediate: true,
    },
  },
  methods: {
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.getData()
      })
    },
    getData() {
      if (!this.scmCode) return
      this.loading = true
      this.$api
        .scmInfoVisitListApi({ scmCode: this.scmCode, ...this.page })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },

    confirm() {
      this.dialogFormVisible = true
    },
    scoreTemplateDialogOpened() {
      this.$refs.scoreTemplate.init()
    },
    choiceScoreTemplateSuccess(val) {
      let appraisalBillCode = val.appraisalBillCode
      this.addVisitScore(appraisalBillCode)
    },
    choiceScoreTemplateCancel() {
      this.$emit('update:visible', false)
    },
    addVisitScore(appraisalBillCode) {
      let param = {
        scmCode: this.scmCode,
        visitCode: this.visitCode,
        appraisalBillCode,
      }
      this.$api.addVisitScoreApi(param).then((res) => {
        let visitScoreCode = res.body
        this.$emit('colse')
        this.$router.push({
          name: 'personal-myScmInfo-myVisit-rating-edit',
          params: {
            pageType: 'edit',
            visitScoreCode: visitScoreCode,
          },
        })
      })
    },
  },
}
</script>
<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
